import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-bubblechart',
  templateUrl: './bubblechart.component.html',
  styleUrls: ['./bubblechart.component.scss']
})
export class BubblechartComponent {

  @Input() data: any;

  bubbleChartData: any;
  bubbleChartOptions: any;
  
  constructor( private dataService: DataService,) {}

  async ngOnInit(): Promise<void> {
    // Format your MongoDB data here
    const rawData = await this.getDataFromArg(this.data);

    this.bubbleChartData = {
      labels: rawData.map((item: any) => item.key),
      datasets: [
        {
          data: rawData.map((item: any) => ({
            x: Math.random() * 100, // X-coordinate (random for demonstration)
            y: Math.random() * 100, // Y-coordinate (random for demonstration)
            r: item.count > 100 ? item.count/10 : item.count  , // Radius of the bubble based on 'count'
          })),
          backgroundColor: '#77318cb8', // Customize the bubble color
        },
      ],
    };
  
    // Configure chart options (you can customize this further)
    this.bubbleChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      
      // legend: { display: false },
      // scales: {
      //   xAxes: [{ display: false }],
      //   yAxes: [{ display: false }],
      // },
    };
  }

  async getDataFromArg(data: any) {
    let res = await this.dataService.postData('dashboards/dynamic-aggregation', {
      "aggregation": data.aggregation,
      "tableName": data.table
    }); 

    return res.data;
  }
}
